const Skeleton = () => (
	<div className="Skeleton">
		<div className="Page-navbar">
			<div className="Page-toggle">
				<div className="Dropdown Buble Buble--circle" />
			</div>
			<div className="Page-logo">
				<div className="Dropdown Buble Buble--logo" />
			</div>
			<div className="Dropdown Page-item">
				<div className="Dropdown Buble" />
			</div>
			<div className="Dropdown Page-item">
				<div className="Dropdown Buble Buble--circle" />
			</div>
			<div className="Dropdown Page-item">
				<div className="Dropdown Buble Buble--big" />
			</div>
		</div>
		<div className="Page-container">
			<div className="Page-sidebar Page-leftMenu">
				<div className="Menu Menu--darkTheme">
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
					<div className="Menu-item">
						<div className="Menu-link Link">
							<div className="Menu-label">
								<div className="Menu-icon">
									<div className="Dropdown Buble Buble--circle" />
								</div>
								<div className="Dropdown Buble Buble" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="Page-mainWrapper">
				<div className="Page-main">
					<div className="Panel Panel-skeleton">
						<div className="Panel-main">
							<div className="Square" />
						</div>
					</div>
				</div>
			</div>
			<div className="Page-aside">
				<div className="Sidebar">
					<div className="Sidebar-heading">
						<div className="Dropdown Buble Buble--big" />
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default Skeleton;
